//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/importP4/views/main/lan/es';
import newMigration from 'Modules/importP4/views/main/.components/newMigration/lan/es';
import exceptionDetails from 'Modules/importP4/views/main/.components/exceptionDetails/lan/es';

locales = {
    ...locales,
    ...main,
    ...newMigration,
    ...exceptionDetails,
};

export default locales;